import { render } from "./newFinance.vue?vue&type=template&id=4696386e"
import script from "./newFinance.vue?vue&type=script&lang=js"
export * from "./newFinance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__